<button
  (click)="handleCommandClick()"
  class="link">
  <ng-content />
</button>
